import { Group, Select } from '@byecode/ui'
import type { NodeTypes } from '@lighthouse/shared'
import { ListItem4ByecodeUi, nodeTypeOptions } from '@lighthouse/shared'
import React from 'react'

import * as SC from '../styles'

interface RefreshUserPermissionsActionConfigureProps {
    nodeType?: NodeTypes
    actionTypeSwitcher?: React.ReactNode
}

export const RefreshUserPermissionsActionConfigure: React.FC<RefreshUserPermissionsActionConfigureProps> = ({
    actionTypeSwitcher,
    nodeType
}) => {
    return (
        <SC.Container>
            <Group label="动作配置">
                <ListItem4ByecodeUi>
                    <SC.FormItemLabelWrapper>
                        <SC.FormItemLabel>类型</SC.FormItemLabel>
                    </SC.FormItemLabelWrapper>
                    <SC.FormItemContent>
                        {actionTypeSwitcher || <Select disabled value={nodeType} options={nodeTypeOptions} />}
                    </SC.FormItemContent>
                </ListItem4ByecodeUi>
            </Group>
        </SC.Container>
    )
}
